import { ImageFilterHdrIcon } from './ImageFilterHdrIcon';

/**
 * author: Google
 * id 999CF81E-71B7-48E1-8B8F-70FDE391F647
 * name image-filter-hdr
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/image-filter-hdr.svg
 * tags
 * - Photography 
 * - Nature 
 */
export const LandscapeIcon = ImageFilterHdrIcon;
export default LandscapeIcon